"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Twitter = function Twitter(props) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25"
  }, props), (0, _core.jsx)("path", {
    d: "M38.084 9.789a12.436 12.436 0 01-3.536.953 6.096 6.096 0 002.707-3.351 12.45 12.45 0 01-3.908 1.47 6.196 6.196 0 00-4.494-1.913c-3.399 0-6.155 2.713-6.155 6.058 0 .475.055.937.16 1.381a17.564 17.564 0 01-12.686-6.33 5.954 5.954 0 00-.834 3.045c0 2.102 1.087 3.957 2.738 5.044a6.197 6.197 0 01-2.788-.759v.077c0 2.936 2.122 5.384 4.938 5.94a6.228 6.228 0 01-2.78.105c.783 2.407 3.056 4.158 5.75 4.207A12.47 12.47 0 019.55 28.31c-.496 0-.987-.029-1.467-.085a17.61 17.61 0 009.434 2.723c11.321 0 17.513-9.232 17.513-17.24 0-.262-.006-.523-.019-.784a12.38 12.38 0 003.072-3.135",
    fill: "currentColor",
    transform: "translate(-8 -6)"
  }));
};

var _default = Twitter;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Twitter, "Twitter", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/assets/Twitter.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/assets/Twitter.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();